<template>
  <PageWrapper
    :active-section="SECTION_MONETIZATION"
    :active-page="PAGE_LINKS_COLLECTIONS"
    title="Affiliate Link Collections"
    page-name="Collections"
    :breadcrumbs="breadcrumbs"
    action-button-text="Create New Collection"
    @click:action="openCreateCollectionModal"
  >
    <SmartFeed :source="useMyMonetizationLinkCollectionFeedStore" />
  </PageWrapper>
  <!-- The v-if is here specifically to load the editingCollection change when we trigger an edit -->
  <CollectionDetailsModal
    v-if="showCollectionModal"
    :open="showCollectionModal"
    :affiliate-link-collection="editingCollection"
    @close="closeCollectionModal"
  />
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import { mapState, mapWritableState } from "pinia";
import { useAffiliateLinkStore } from "%/stores/affiliate-link-store";
import { SECTION_MONETIZATION, PAGE_LINKS_COLLECTIONS } from "@/constants/nav-constants";
import CollectionDetailsModal from "@/components/CollectionDetailsModal";
import SmartFeed from "SmartFeed/components/SmartFeedV2";
import {
  useMyMonetizationLinkCollectionFeedStore,
} from "@/smart-feed/stores/feed/my-monetization-link-collection-feed-store";
export default {
  name: "LinkCollections",
  components: {
    PageWrapper,
    CollectionDetailsModal,
    SmartFeed,
  },
  props: {},
  data() {
    return {
      SECTION_MONETIZATION,
      PAGE_LINKS_COLLECTIONS,
    };
  },
  computed: {
    ...mapState(useAffiliateLinkStore, [
      "collections",
      "orgId",
    ]),
    ...mapWritableState(useAffiliateLinkStore, [
      "showCollectionModal",
      "editingCollection",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/monetization/org/${this.orgId}`, label: "Monetization" },
        { url: `/monetization/org/${this.orgId}/links`, label: "My Links" },
      ];
    },
  },
  methods: {
    closeCollectionModal() {
      this.editingCollection = {};
      this.showCollectionModal = false;
    },
    openCreateCollectionModal() {
      this.editingCollection = {};
      this.showCollectionModal = true;
    },
    openEditCollectionModal(collection) {
      this.editingCollection = collection;
      this.showCollectionModal = true;
    },
    useMyMonetizationLinkCollectionFeedStore,
  },
};
</script>
